import ReactInputMask from 'react-input-mask'

import styled, { createGlobalStyle } from 'styled-components'

import { ReactComponent as ChevronSvg } from '../assets/icons/arrow-chevron-down.svg'

import { colors } from './constants'

export default createGlobalStyle`

  *{
    &:focus {
        box-shadow: none !important;
    }
    margin:0;
    padding:0;
    outline:0;
    box-sizing:border-box;
    font-family: 'Nunito', sans-serif;
  }

  html, body, #root{
    min-height: 100vh;
  }

  #root{
    display: flex;
    flex-direction: column;
  }

  body {
    background: ${colors.white};
    color: ${colors.black};
    -webkit-font-smoothing: antialiased !important;
    overflow-x:hidden;
  }

  .swal2-icon-success .colorWhite{
    color: ${colors.white};
  }

  .swal2-html-container {
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 400;
      font-size: 13px;
      line-height: 19px;
      text-align: center;
      color: ${colors.gray.darkerGray};
      margin: 16px 0;
  }

  .swal2-confirm {
    :hover {
        background: #FFFFFF;
    }
    &.outline {
      border-radius: 8px;
      border: 1px solid #028BB7;
      font-family: 'Open sans';
      font-size: 16px;
      background-color: #FFFFFF;
      color: #028BB7;
      padding: 8px 16px;
      margin: 0 8px;
      flex: 1 0 0;
      height: 48px;
    }
  }

  .swal2-styled.swal2-cancel {
    :hover {
        background: #028BB7 !important;
    }
    border-radius: 8px;
    font-family: 'Open sans';
    font-size: 16px;
    flex: 1 0 0;
    background-color: #028BB7;
    color: #FFFFFF;
    padding: 8px 16px;
    margin: 0 8px;
    height: 48px;
  }

  .swal2-icon-error .colorBlack{
    color: ${colors.black};
  }
  .checkboxList {
    width: 100%;
    padding: 0 15px;
    display: flex;
    flex-wrap: wrap;
    > div {
      margin-bottom: 15px;
    }
    &.expanded {
      padding: 0;
      > div {
        padding-left: 25px;
        &:first-child {
          padding-left: 0;
        }
      }
    }
  }
  .swal2-container.no-circle {
    .swal2-icon {
      border: none;
    }
    .swal2-title {
      padding-top: 0;
    }
    .swal2-html-container {
      margin-top: 16px;
    }
  }
  .swal2-container.NoInformationFound {
    .swal2-modal {
      padding-bottom: 1rem;
      display: flex;
      flex-direction: column;
      gap: 1rem;
      padding: 1rem;
      max-width: 328px;
    }
    .swal2-icon {
      &.withoutCloseButton {
        margin: 0 auto;
        height: 64px;
      }
    }
    .swal2-title {
      padding: 0;
      font-family: 'Nunito';
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 19px;
      text-align: center;
      letter-spacing: 0.96px;
      color: ${colors.gray.darker};
    }
    .swal2-html-container {
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 400;
      font-size: 13px;
      line-height: 19px;
      text-align: center;
      color: ${colors.gray.darkerGray};
      margin: 0;
    }
    .swal2-actions,
    .swal2-actions button {
      margin: 0;
    }
  }
  .swal2-popup {
    border-radius: 8px;
    min-width: 752px;
    .primaryButton {
      width: 296px;
      height: 48px;
      border-radius: 8px;
      font-family: 'Open sans';
      font-weight: 600;
      font-size: 16px;
      line-height: 21.79px;
      padding: 8px 16px;
      &:focus {
        box-shadow: none;
      }
    }

    .swal2-close {
      width: 24px;
      height: 24px;
      margin-top: 16px;
      margin-right: 16px;
      color: ${colors.gray.medium};
    }
  }
`
export const Container = styled.div`
  width:100%;
  padding: .5rem;
  margin:0 auto;

  ${props => props.bg && `background: ${props.bg};`}
  ${props => props.flex && `
    display: flex;
    flex-direction: column;
    align-items: center;
  `}
`

export const InputGroup = styled.div`
  display:flex;
  flex-direction:column;
  margin-bottom:20px;

  &.m-bottom-10 {
    margin-bottom: 10px;
  }
`
export const Label = styled.label`
  font-size:22px;
  font-weight:bold;
  margin-bottom:10px;
`
export const Select = styled.select`
  border-radius:5px;
  border:2px solid ${colors.gray.lighter};
  height:49px;
  padding:0 55px 0 15px;
  color: ${colors.black};
  font-size:18px;
  appearance: none;
  position:relative;
  background-image: url('../assets/icons/arrow-chevron-down.svg');
  background-repeat:no-repeat;
  background-position:calc(100% - 16px) center;
`
export const Input = styled.input`
  border-radius:5px;
  border:2px solid ${colors.gray.lighter};
  height:49px;
  padding:0 15px;
  color: ${colors.black};
  font-size:18px;
`
export const InputMask = styled(ReactInputMask)`
  border-radius:5px;
  border:2px solid ${colors.gray.lighter};
  height:49px;
  padding:0 15px;
  color: ${colors.black};
  font-size:18px;
`
export const Button = styled.button`
  color: ${colors.white};
  border-radius:8px;
  padding:8px 0;
  font-size:16px;
  font-weight: 700;
  border:none;
  background:#00A3B4;

  &:disabled{
    background: ${colors.gray.default};
    color: ${colors.gray.light};
  }
`

export const ErrorMessage = styled.span`
  color:#FF0000;
  font-size:15px;
  margin-left:16px;
  margin-top:5px;
`

export const Chevron = styled(ChevronSvg)`
  cursor: pointer;
  height: 35px;
  width: 35px;
  padding: 5px;

  ${({ direction }) => direction && direction === 'left'
    ? 'transform: rotate(90deg);'
    : direction === 'right'
      ? 'transform: rotate(-90deg);'
      : direction === 'up'
        ? 'transform: rotate(180deg);'
        : ''
  }

  .a {
    fill: ${props => props.fill ? props.fill : '#47a8b7'};
  }
`

export const LinkContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  font-family: var(--font-family);
  font-size: 15px;
  font-weight: normal;
  margin-bottom: 10px;
`

export const CustomButton = styled(Button)`
  width: 100%;
  height: 50px;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.96px;
  border-radius: 8px;
  background-color: ${props => props.outline ? `${colors.white}` : `${colors.cyan.default}`};
  border: 1px solid ${props => props.outline ? `${colors.cyan.default}` : `${colors.white}`};
  margin-bottom: 15px;
  color: ${props => props.outline ? `${colors.cyan.default}` : `${colors.white}`};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    margin-right: 15px;
  }
`
